import { articleService } from '../../../services/article.service'
import dynamic from 'next/dynamic';
import Footer from '../../../components/Layouts/Footer';
import { serverLocationDetector } from '../../../utils/locationDetector';
const Layout = dynamic(() => import('../../../components/_App/Layout'))
const Article = dynamic(() => import('../../../templates/Article'))
const Error404 = dynamic(() => import('../../404'))

export default function ArticleWrapper({isAppleMobile, article, categories, twitterTags, relatedArticles, code}){

   
    
    return(
        <Layout 
            isAppleMobile = {isAppleMobile}
            
            seo={{
                description: article.metadata,
                image: article.picture ? article.picture.replace('upload/', 'upload/c_fill,h_200,w_200/') : '/static/icons/favicon.png',
                title: article.name+' | Weedzly',
                url:`https://weedzly.com/library/${article.slug}`
            }}
        >
            <Article 
                article={article} 
                categories={categories} 
                twitterTags={twitterTags}
                relatedArticles={relatedArticles} 
            />
           
        </Layout>
    )
}


export async function getServerSideProps(context){
    
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

        await serverLocationDetector(context)

    try {

        const slug = context.params.article
        const {article, categories, relatedArticles} = await articleService.getBySlug(slug)
        const twitterTags = tagsFormatter(article.tags)

        let inf = article.content

        let i = 0
        let c = 0
       
        let h2f = (inf && inf.includes('<h2>')) ? inf.match(new RegExp('<h2>', "g")).length : 0
        let h3f = (inf && inf.includes('<h3>')) ? inf.match(new RegExp('<h3>', "g")).length : 0
        

      
        for(i = 0; i < h2f; i++){
            inf = inf.replace('<h2>', `<h2 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h3f; i++){
            inf = inf.replace('<h3>', `<h3 id="${c}">`)
            c = c + 1
        }
        

        if(inf){
            article.content = inf
        }

        return {
            props:{
                isAppleMobile,
                article, 
                categories, 
                twitterTags, 
                relatedArticles,
            }
        }

    } catch({code, message}) {
        if(code && code === 404){
            return {
                notFound: true,
              }
        }
        return {
            props:{
                isAppleMobile,
                code, 
                message, 
            }
        }

    }
}

const tagsFormatter = (tags) =>{
    var _tags=[]; 
    tags.map(tag => {
      _tags=[..._tags, tag.name.replace(/\s/g, '_')];
    })
    return _tags
}